<script setup>
import { useLayout } from '@/layout/composables/layout';
import { computed, ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import AppFooter from './AppFooter.vue';
import AppSidebar from './AppSidebar.vue';
import AppTopbar from './AppTopbar.vue';
import subscriptionModal from '@/components/subscriptionModal.vue';
import SubscriptionBlockedOverlay from '@/components/SubscriptionBlockedOverlay.vue';
import ConnectModal from '@/components/ConnectModal.vue';
import KeyboardShortcutsHelp from '@/components/KeyboardShortcutsHelp.vue';
import OnboardingTour from '@/components/onboarding/OnboardingTour.vue';
import { useKeyboardNav } from '@/composables/useKeyboardNav';
import { useUserStore } from '../stores/user'

const userStore = useUserStore()
const router = useRouter();
const helpVisible = ref(false);
useKeyboardNav(router, helpVisible);

const { layoutConfig, layoutState, isSidebarActive } = useLayout();

const outsideClickListener = ref(null);

onMounted(async () => {
  await userStore.getUserAccountId()
  await userStore.checkSubscriptionStatus()
})

watch(isSidebarActive, (newVal) => {
    if (newVal) {
        bindOutsideClickListener();
    } else {
        unbindOutsideClickListener();
    }
});

const containerClass = computed(() => {
    return {
        'layout-overlay': layoutConfig.menuMode === 'overlay',
        'layout-static': layoutConfig.menuMode === 'static',
        'layout-static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive,
        'layout-mobile-active': layoutState.staticMenuMobileActive
    };
});

function bindOutsideClickListener() {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event) => {
            if (isOutsideClicked(event)) {
                layoutState.overlayMenuActive = false;
                layoutState.staticMenuMobileActive = false;
                layoutState.menuHoverActive = false;
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
}

function unbindOutsideClickListener() {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener);
        outsideClickListener.value = null;
    }
}

function isOutsideClicked(event) {
    const sidebarEl = document.querySelector('.layout-sidebar');
    const topbarEl = document.querySelector('.layout-menu-button');

    return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
}
</script>

<template>
    <div class="layout-wrapper" :class="containerClass">
        <app-topbar></app-topbar>
        <app-sidebar></app-sidebar>
        <div class="layout-main-container">
            <div class="layout-main">
                <subscriptionModal />
                <SubscriptionBlockedOverlay />
                <ConnectModal />
                <KeyboardShortcutsHelp v-model:visible="helpVisible" />
                <OnboardingTour />
                <router-view></router-view>
            </div>
            <app-footer></app-footer>
        </div>
        <div class="layout-mask animate-fadein"></div>
    </div>
    <Toast />
</template>
